interface LogoProps {
  size?: number;
  className?: string;
}

export function Logo({ size = 22, className = "" }: LogoProps) {
  return (
    <img
      src="/revetra-mark-ink.svg"
      alt="Revetra"
      style={{ width: size, height: size }}
      className={`inline-block flex-shrink-0 ${className}`}
    />
  );
}

interface WordmarkProps {
  className?: string;
  size?: number;
  // Tailwind class controlling the "Revetra" wordmark text size. The
  // reference uses 22px in the nav and 16px in the footer; defaults to
  // the larger 30px used elsewhere so existing call sites are unchanged.
  textClassName?: string;
}

export function Wordmark({ className = "", size = 34, textClassName = "text-[30px]" }: WordmarkProps) {
  return (
    <span className={`inline-flex items-center gap-3 text-ink ${className}`}>
      <Logo size={size} />
      <span className={`font-serif tracking-tight ${textClassName}`}>Revetra</span>
    </span>
  );
}
